import { render } from "./OneOnOneListHeaderCard.vue?vue&type=template&id=18fdb55a&scoped=true"
import script from "./OneOnOneListHeaderCard.vue?vue&type=script&lang=js"
export * from "./OneOnOneListHeaderCard.vue?vue&type=script&lang=js"

import "./OneOnOneListHeaderCard.vue?vue&type=style&index=0&id=18fdb55a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18fdb55a"

export default script